module.exports = "/images/background-5.jpg";